module.exports = __webpack_public_path__ + "img/health-project.5b82678f.png";